export { default } from './CssBaseline';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/CssBaseline/index.js
// module id = 319
// module chunks = 0